/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 1.0.0
 * @file Temporal file to check business Unit
 */

export function checkBusinessUnitReverse(bu) {
  var result = "";
  switch (bu) {
    case 1:
      result = "Culiacán";
      break;
    case 2:
      result = "Vallarta";
      break;
    case 3:
      result = "Tijuana";
      break;
    case 4:
      result = "Tuxpan";
      break;
  }
  return result;
}

export function checkBusinessUnit(bu) {
  var result = null;
  switch (bu) {
    case "Culiacan":
      result = 1;
      break;
    case "Culiacán":
      result = 1;
      break;
    case "Vallarta":
      result = 2;
      break;
    case "Tijuana":
      result = 3;
      break;
    case "Tuxpan":
      result = 4;
      break;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/checkBusinessUnit.js